module.exports = __webpack_public_path__ + "img/1572.5975a10a.svg";